<script type="text/javascript">
import size from 'lodash/size';
import unionBy from 'lodash/unionBy';
import groupBy from 'lodash/groupBy';
import filter from 'lodash/filter';
import { http } from '../../http';
import DatePicker from "./form/DatePicker";

export default {

    props: {
        initial_notification_count : {
            default : 0
        },
        important_notifications : {
            default : 0
        }
    },

    data() {
        return {
            new_notification_count: this.initial_notification_count.new_notifications,
            stickied_notification_count: this.initial_notification_count.stickied_notifications,
            active_tab: 'notifications',
            notifications_loading: false,
            activity_log_loading: true,
            notifications: [],
            notifications_next_page_url: null,
            notifications_all_loaded: false,
            activity_log: [],
            activity_log_next_page_url: null,
            activity_log_active_date: null,
            activity_log_all_loaded: false,
            activity_log_next_page_loader: false,
            important_messages: [],
            opened: false,
        }
    },

    components: {
        DatePicker
    },

    mounted() {
        $(document).mousedown((e) => {
            const container = $(".notification-box .notification-dropdown, .flatpickr-calendar, .notification-box a.notification-menu-item.bell-icon");

            // if the target of the click isn't the container nor a descendant of the container
            if (!container.is(e.target) && container.has(e.target).length === 0) {
                this.opened = false;
            }
        });
    },

    methods: {
        size,

        showRelatedUrl(url) {
            if (url.type === 'client' && this.client_id) {
                return false;
            }

            if (url.type === 'invoice' && this.invoice_id) {
                return false;
            }

            return true;
        },

        emit(related_url) {
            setTimeout(() => {
                if (related_url.emit.data) {
                    this.$event_bus.$emit(related_url.emit.event, ...related_url.emit.data);
                } else {
                    this.$event_bus.$emit(related_url.emit.event);
                }
            }, 500);
        },

        itemAction(item) {
            if (item.action) {
                this.$event_bus.$emit(item.action);
            } else {
                window.location = item.link;
            }
        },

        getNotifications(show_loading) {
            if (this.notifications_all_loaded) {
                return false;
            }

            if (show_loading) {
                this.notifications_loading = true;
            }

            let url = '/app/userlog/notifications';

            if (this.notifications_next_page_url) {
                url = this.notifications_next_page_url;
            }

            http.get(url)
                .then(({data}) => {
                    this.notifications_loading = false;
                    this.notifications = unionBy(this.notifications, data.data, "id");
                    this.notifications_next_page_url = data.links.next;
                    this.new_notification_count = data.notifications_count;

                    if (!data.links.next) {
                        this.notifications_all_loaded = true;
                    }
                })
                .catch(({error, errorBag}) => {
                    this.notifications_loading = false;
                });
        },

        getImportantMessages() {
            http.get('/app/userlog/important_messages')
                .then(({data}) => {
                    this.important_messages = data;
                })
                .catch(({error, errorBag}) => {
                });
        },

        getActivityLog() {
            if (this.activity_log_all_loaded) {
                return false;
            }

            this.activity_log_loading = true;
            this.activity_log_next_page_loader = false;

            let url = '/app/userlog/activity_log?';

            if (this.activity_log_next_page_url) {
                url += "&page=" + this.activity_log_next_page_url;
                this.activity_log_next_page_loader = true;
                this.activity_log_loading = false;
            }

            if (this.activity_log_active_date) {
                url += "&date=" + this.activity_log_active_date;
            }

            http.get(url)
                .then(({ data }) => {
                    this.activity_log_loading = false;
                    this.activity_log_next_page_loader = false;

                    this.activity_log = unionBy(this.activity_log, data.data, "id");

                    if (data.links && data.links.next) {
                        this.activity_log_next_page_url = data.meta.current_page + 1;
                    } else if (data.next_page_url) {
                        // for backwards compatibility with the non-resource based response
                        this.activity_log_next_page_url = data.current_page + 1;
                    } else {
                        this.activity_log_all_loaded = true;
                    }

                })
                .finally(({ data }) => {
                    this.activity_log_loading = false;
                    this.activity_log_next_page_loader = false;
                })
                .catch(({ error, errorBag }) => {
                    this.activity_log_loading = false;
                });
        },

        markNotificationAsRead(id) {
            this.removeNotificationById(id);

            http.post('/app/userlog/notifications/' + id)
                .then(({data}) => {
                    this.stickied_notification_count = this.stickied_notification_count - data.notifications_cleared;
                    this.notifications_next_page_url = null;
                    this.getNotifications(false);
                })
                .catch(({error, errorBag}) => {});
        },

        markNotificationFromDateAsRead(date) {
            this.removeNotificationsByDate(date);

            http.post('/app/userlog/notifications/mark-all-from-date', {date: date})
                .then(({data}) => {
                    this.stickied_notification_count = this.stickied_notification_count - data.notifications_cleared;
                    this.notifications_next_page_url = null;
                    this.getNotifications(false);
                })
                .catch(({error, errorBag}) => {});
        },

        removeNotificationById(id) {
            this.notifications = filter(this.notifications, (notification) => notification.id !== id);
        },

        removeNotificationsByDate(date) {
            this.notifications = filter(this.notifications, (notification) => moment(notification.date).format('YYYY-MM-DD') !== date);
        },

        formatDate(date) {
            let dateObj = moment(date);

            if (dateObj.isSame(moment(), 'd')) {
                return trans('app.today');
            }

            return dateObj.locale(moment_locale).format('dddd, LL');
        },

        open() {
            this.notifications_next_page_url = null;
            this.opened = this.opened ? 0 : 1;
        }
    },

    computed: {
        notifications_grouped() {
            return groupBy(this.notifications, item => moment(item.date).format('YYYY-MM-DD'));
        },

        activity_log_grouped() {
            return groupBy(this.activity_log, item => moment(item.date).format('YYYY-MM-DD'));
        },

        has_notifications_to_show() {
            return this.new_notification_count > 0 || this.stickied_notification_count > 0 || this.important_notifications > 0 || this.notifications.length > 0;
        },

        new_notification_count_for_red_bubble() {
            if (this.new_notification_count > 9) {
                return "9+";
            }

            return this.new_notification_count;
        },

        has_activity_to_show() {
            return this.activity_log.length > 0 || !this.activity_log_all_loaded || this.activity_log_loading;
        },

        emptyStateImageSuffix() {
            return this.$store.getters.isNordhealthBrand ? '_nh' : '';
        },
    },

    watch: {
        activity_log_active_date(val, oldVal) {
            if (val !== oldVal) {
                this.activity_log = [];
                this.activity_log_all_loaded = false;
                this.activity_log_next_page_url = null;
                this.getActivityLog();
            }
        },

        opened(val, oldVal) {
            if (val) {
                this.activity_log_next_page_url = null;
                this.getNotifications(true);
                this.getActivityLog();
                this.getImportantMessages();
            }
        },
    }
};
</script>

<template id="notification-menu-item">
    <div class="notification-box notification-menu-wrapper" :class=" { 'has-important-messages' : important_notifications }">
        <div class="position-relative">
            <nord-button @click.prevent="open" variant="plain">
                <nord-icon name="navigation-notifications" :class=" { 'n-color-text-danger' : important_notifications }" size="l"></nord-icon>
                <span class="n-color-text-danger" slot="end" v-if="important_notifications">{{ trans('global.important_information') }}</span>
            </nord-button>

            <div class="new-notifications-marker" v-if="new_notification_count">
                <span class="dot-marker">{{ new_notification_count_for_red_bubble }}</span>
            </div>
        </div>

        <div class="notification-dropdown" v-if="opened">
            <div class="tabs-nav">
                <ul>
                    <li :class="{ 'active' : active_tab === 'notifications'}">
                            <a href="" @click.prevent="active_tab = 'notifications'">
                            <i v-if="initial_notification_count.new_notifications" class="zmdi zmdi-circle m-r-5" style="color:red; font-size:12px;"></i>
                            {{ trans('global.notification_menu_notifications') }}
                        </a>
                    </li>
                    <li :class="{ 'active' : active_tab === 'activity'}"><a href="" @click.prevent="active_tab = 'activity'">{{ trans('global.notification_menu_activity') }}</a></li>
                </ul>
            </div>

            <div class="important-notifications" v-if="active_tab === 'notifications' && important_messages.length">
                <div class="important-content">
                    <div class="notification-day">

                        <div class="row m-b-10 p-t-10">
                            <div class="col-xs-12" style="line-height:20px;">
                                <b>{{ trans('global.important_information') }}</b>
                            </div>
                        </div>

                        <div class="notification-item" v-for="important_message in important_messages">
                            <span v-sanitize-html="important_message.text"></span>
                            <small class="truncate" v-if="important_message.link"><a href="" @click.prevent="itemAction(important_message)">{{ important_message.link_title }}</a></small>
                        </div>

                    </div>

                </div>
            </div>

            <div class="notification-content" v-show="active_tab === 'notifications'">

                <template v-if="notifications_loading && has_notifications_to_show">
                    <div class="text-center">
                        <div class="preloader"></div>
                    </div>
                </template>

                <template v-else>

                    <!-- notifications_grouped: object -->
                    <template v-if="notifications.length">
                        <div class="notification-day" v-for="(notification_group, date) in notifications_grouped">

                            <div class="notification-day-heading">
                                <div class="row m-b-10">
                                    <div class="col-xs-6">
                                        <b>{{ $filters.capitalize(formatDate(date)) }}</b>
                                    </div>
                                    <div class="col-xs-6 text-right">
                                        <small><a href="" @click.prevent="markNotificationFromDateAsRead(date)">{{ trans('global.notification_clear') }}</a></small>
                                    </div>
                                </div>
                            </div>

                            <!-- notification_group: array -->
                            <div class="notification-item" v-for="notification in notification_group">

                                <a href="" class="notification-close" @click.prevent="markNotificationAsRead(notification.id)"><i class="zmdi zmdi-close"></i></a>

                                <i v-if="notification.new" class="zmdi zmdi-circle notification-item-new-dot"></i>

                                <span v-sanitize-html="notification.text"></span> <small class="text-muted">{{ notification.time_formatted }}</small>

                                <div class="notifications-item-links" v-if="notification.related_urls.length">
                                    <!-- related_urls: array -->
                                    <template v-for="(related_url, url_index) in notification.related_urls" >
                                        <small class="related-url m-r-10" v-if="showRelatedUrl(related_url)" :key="url_index">
                                            <a v-if="related_url.url && !related_url.emit" :href="related_url.url" :class="{ 'show-in-popup' : related_url.async }">{{ related_url.label }} </a>
                                            <em v-if="!related_url.url && !related_url.emit">{{ related_url.label }}</em>
                                            <a v-if="related_url.emit" href="javascript:void(0);" @click="emit(related_url)">{{ related_url.label }}</a>
                                        </small>
                                    </template>
                                </div>

                            </div>

                        </div>
                    </template>
                    <div class="notifications-show-more m-b-10 m-l-10 m-r-10 m-t-10" v-if="notifications_next_page_url">
                        <a href="" @click.prevent="getNotifications(false)" class="text-center btn btn-block btn-custom btn-trans btn-sm" >{{ trans('calendar.show_more') }} <i class="zmdi zmdi-chevron-down m-l-5"></i></a>
                    </div>

                    <div class="p-20 text-center notification-empty-state" v-if="!has_notifications_to_show">
                        <img :src="`/images/app/global/no_notifications${emptyStateImageSuffix}.png`" alt="">
                        <h4 class="m-b-0">{{ trans('global.notification_menu_no_notifications') }}</h4>
                    </div>

                </template>


            </div>

            <div class="activity-content" v-show="active_tab === 'activity'">
                <div class="activity-log-date-picker p-10">
                    <div class="row">
                        <div class="col-xs-12 col-sm-6">
                            <div class="form group">
                                <label for="activity-log-date-picker" class="control-label">{{ trans('global.notification_menu_activity_show') }}</label>
                                <date-picker
                                    id="activity-log-date-picker"
                                    name="activity-log-date-picker"
                                    v-model="activity_log_active_date"
                                    :clearable="true"
                                ></date-picker>
                            </div>
                        </div>
                    </div>
                </div>

                <template v-if="activity_log.length">
                    <div class="notification-day relative" v-for="(activity_log_group, date) in activity_log_grouped">
                        <div class="notification-day-heading">
                            <div class="row m-b-10 ">
                                <div class="col-xs-12" style="line-height:20px;">
                                    <b>{{ $filters.capitalize(formatDate(date)) }}</b>
                                </div>
                            </div>
                        </div>

                        <div class="notification-item" v-for="log_entry in activity_log_group">
                            <span v-sanitize-html="log_entry.text"></span> <small class="text-muted">{{ log_entry.time_formatted }}</small>
                            <div class="notifications-item-links" v-if="log_entry.related_urls.length">
                                <template v-for="(related_url, url_index) in log_entry.related_urls" >
                                    <small class="related-url m-r-10" v-if="showRelatedUrl(related_url)" :key="url_index">
                                        <a v-if="related_url.url && !related_url.emit" :href="related_url.url" :class="{ 'show-in-popup' : related_url.async }">{{ related_url.label }} </a>
                                        <em v-if="!related_url.url && !related_url.emit">{{ related_url.label }}</em>
                                        <a v-if="related_url.emit" href="javascript:void(0);" @click="emit(related_url)">{{ related_url.label }}</a>
                                    </small>
                                </template>
                            </div>
                        </div>

                    </div>
                </template>

                <template v-if="activity_log_loading && has_activity_to_show">
                    <div class="text-center">
                        <div class="preloader"></div>
                    </div>
                </template>

                <div v-else-if="activity_log.length === 0" class="notification-empty-state p-l-10 p-r-10"><h4 class="text-center m-b-10 m-t-10">{{ trans('global.notification_menu_no_activity') }}</h4></div>

                <div class="notifications-show-more m-b-10 m-l-10 m-r-10 m-t-10" v-if="activity_log_next_page_loader">
                    <a href="" class="text-center btn btn-custom btn-block btn-trans btn-sm collapsed m-r-10 m-t-15 has-preloader disabled" >
                        <div class="preloader" style="height: 13px; margin: 0 !important; width: 13px;"></div>
                    </a>
                </div>
                <div class="notifications-show-more m-b-10 m-l-10 m-r-10 m-t-10" v-else-if="activity_log_next_page_url && !activity_log_all_loaded">
                    <a href="" @click.prevent="getActivityLog()" class="text-center btn btn-custom btn-block btn-trans btn-sm collapsed m-r-10 m-t-15 has-preloader" >
                        <div v-if="!activity_log_all_loaded">
                            {{ trans('calendar.show_more') }} <i class="zmdi zmdi-chevron-down m-l-5"></i>
                        </div>
                    </a>

                </div>

            </div>
        </div>
    </div>
</template>
